import pagesdata from "./pagesdata";
import flatten from "./flattenarray";

// "ItemAdder_A",
// "L1Approver_A",
// "L2Approver_A",
// "L1ReqApprover_A",
// "L2ReqApprover_A",
// "ItemAdder_C",
// "L1Approver_C",
// "L2Approver_C",
// "L1ReqApprover_C",
// "L2ReqApprover_C",
// "L1Support",
// "L2Support"

const userArray = ["Home", "Dashboard", "Management", "Assets", "MyAssets", "MyRequests", "AddNew", "Inbox", "Sent",
   "ClosedReq","HandoverRequest", "Complaints", "MyComplaints", "RegisterComplaint","UserCompInbox",
   "UserCompSentbox", "IssueReq", "HandoverReq", "Users", "ChangeOfficeReq", "IndividualReq","Consumables",
    "MyConsumables", "ConsumablesReq", "ConsumIssueReq", "UnifiedInbox", "UnifiedSentbox", "UserAssetReturnReq",
     "MyProfile", "ViewProfile", "EditPassword", "LoginSessions", "MyActivity"]
const unitHeadArray = [...userArray].concat("AllAssets", "Users", "MyUsers","AssetTransaction", "EditUsers","ApproveUsers","Unithead", "UHInbox", "UHSent", "ConsumTransac");
const boArray = [...userArray].concat("AllAssets", "Users", "MyUsers", "Bo", "BoInbox","AssetTransaction", "BoSent", "OffAssetHandoverReq", "OffToOffReq", "OffAssetTransReq", "BOTransferReq", "BOStoreReturn", "BoToStoreConsumReq", "BoAssetReturnReq");
const ItemAdder_A = [...userArray].concat(["AssetMan","AddAssets", "StoreAssetTransReq", "StoreToStoreReq", "AssetSurrender", "AssetTransaction","Distribute", "FinalPdfForms"]);
const L1Approver_A = [...userArray].concat(["Assetapprove","AssetTransaction", "AssetSurrender",  "AssetMan","AMinbox", "AMSent", "StoreAssetTransReq", "StoreToStoreReq", "FinalPdfForms"]);
const L2Approver_A = [...userArray].concat(["Assetapprove", "AssetTransaction","AssetMan","AMinbox", "AMSent", "StoreAssetTransReq", "StoreToStoreReq", "FinalPdfForms"]);
const ItemAdder_C = [...userArray].concat(["Consumables", "ConsumMan", "AddConsumables","ConsumableApprove", "CMinbox", "CMsentbox", "DistributeConsum", "SurrenderConsum", "ConsumTransac"]);
const L1Approver_C = [...userArray].concat(["Consumables", "ConsumMan","ConsumableApprove", "CMinbox", "CMsentbox", "ConsumTransac"]);
const L2Approver_C = [...userArray].concat([ "Consumables", "ConsumMan", "ConsumableApprove", "CMinbox", "CMsentbox", "ConsumTransac"]);
const storeL1L2Support = [...userArray].concat(["SupportUsers","ComplaintsSup", "ComplaintsInbox","ComplaintsSentbox"]);
const supportBasic = ["Home","SupportUsers","ComplaintsSup","Management", "UnifiedInbox", "UnifiedSentbox", "ComplaintsInbox","ComplaintsSentbox"]

const includeArrayFilter = (data, filterArray) => {
    let newData = [];
    let tempData = structuredClone(data);
    tempData.forEach((item,i) => {
        let copyItem = {};
        if(filterArray.includes(item.title)){
        Object.assign(copyItem, item);
            if (copyItem.childrens?.length) {
                copyItem.childrens = includeArrayFilter([...copyItem.childrens], filterArray)
            }
        newData.push(copyItem);
        }
        
    })
    return newData;
}
const filtereddata = (Auth, currentOffice) => {

    let finalmodifieddata = [];
    let filterArray = [];
    const temppagedata = structuredClone(pagesdata);
    if (Auth.supportuser) {
      filterArray =  [...supportBasic];

      if(Auth.roles.includes("Supervisor")){
        ["AllSupportUsers", "ReAssignComplaint"].forEach(x => {
          if (!filterArray.includes(x)) {
            filterArray.push(x)
          }
        });
      }
    }
    if (!Auth.supportuser) {
      filterArray = [...userArray];
      if (Auth.roles?.main?.includes("SuperAdmin")) {
        flatten(temppagedata).map(x=>x.title).filter(y => !["AddAssets"].includes(y)).forEach(x => {
          if (!filterArray.includes(x)) {
            filterArray.push(x)
          }
        });
      }
      if (Auth?.roles?.main?.includes("Admin")) {
        flatten(temppagedata).map(x=>x.title).filter(y => !["AddAssets", "Correction", "AssetTags"].includes(y)).forEach(x => {
          if (!filterArray.includes(x)) {
            filterArray.push(x)
          }
        });
      }

      if (Auth?.roles?.[currentOffice]?.includes("UnitHead")) {
        unitHeadArray.forEach(x => {
          if (!filterArray.includes(x)) {
            filterArray.push(x)
          }
        });
      }
      if (Auth?.roles[currentOffice]?.includes("Bo")) {
        boArray.forEach(x => {
          if (!filterArray.includes(x)) {
            filterArray.push(x)
          }
        });
      }

      if (Auth?.roles[currentOffice]?.includes("ItemAdder_A")) {
        ItemAdder_A.forEach(x => {
          if (!filterArray.includes(x)) {
            filterArray.push(x)
          }
        });
      }

      if (Auth?.roles[currentOffice]?.includes("L1Approver_A")) {
        L1Approver_A.forEach(x => {
          if (!filterArray.includes(x)) {
            filterArray.push(x)
          }
        });
      }

      if (Auth?.roles[currentOffice]?.includes("L2Approver_A")) {
        L2Approver_A.forEach(x => {
          if (!filterArray.includes(x)) {
            filterArray.push(x)
          }
        });
      }

      if (Auth?.roles[currentOffice]?.includes("ItemAdder_C")) {
        ItemAdder_C.forEach(x => {
          if (!filterArray.includes(x)) {
            filterArray.push(x)
          }
        });
      }

      if (Auth?.roles[currentOffice]?.includes("L1Approver_C")) {
        L1Approver_C.forEach(x => {
          if (!filterArray.includes(x)) {
            filterArray.push(x)
          }
        });
      }

      if (Auth?.roles[currentOffice]?.includes("L2Approver_C")) {
        L2Approver_C.forEach(x => {
          if (!filterArray.includes(x)) {
            filterArray.push(x)
          }
        });
      }
      
      if (Auth?.roles[currentOffice]?.includes("L1Support") || Auth?.roles[currentOffice]?.includes("L2Support") ) {
        storeL1L2Support.forEach(x => {
          if (!filterArray.includes(x)) {
            filterArray.push(x)
          }
        });          
      }    
    }
    finalmodifieddata = includeArrayFilter(temppagedata, filterArray);
    return finalmodifieddata;
  }



export default filtereddata;
